import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, roundToTwoDecimals } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";
import { MdWarning } from "react-icons/md";

export default function View({ studentUuid, examCycleUuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [studentData, setStudentData] = useState(null);
	const [examCycleData, setExamCycleData] = useState(null);
	const [currentExamCycleResults, setCurrentExamCycleResults] = useState(null);
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getStudentData(),
			getExamCycleData(),
			appContext.getAllSubjects(),
		]);
		setReady(true);
	}

	async function getStudentData() {
		await callApi("get-student-data", { uuid: studentUuid }).then(response => {
			if (response.status === 1) {
				setStudentData(response.data);
			} else {
				appContext.tellError("Could not fetch student data, check your connection");
			}
		})
	}

	async function getExamCycleData() {
		await callApi("get-exam-cycle-data", { uuid: examCycleUuid }).then(response => {
			if (response.status === 1) {
				setExamCycleData(response.data);
			} else {
				appContext.tellError("Could not fetch examcycle data, check your connection");
			}
		})
	}

	function getCurrentExamCycleResults() {
		if(studentData && examCycleData) {
			const examResults = JSON.parse(studentData.examResults);
			let _currentExamCycleResults = examResults.find((item, i) => item.examCycleUuid === examCycleUuid);

			if(_currentExamCycleResults) {
				setCurrentExamCycleResults(_currentExamCycleResults);
			}
		}
	}

	function getSubjectName(subjectUuid) {
		let name = '';

		if(appContext.allSubjects) {
			const subject = appContext.allSubjects.find((item, i) => item.uuid === subjectUuid);

			if(subject) {
				name = subject.name;
			}
		}

		return name;
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getCurrentExamCycleResults();
	}, [ studentData, examCycleData ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && studentData && examCycleData) {
		return (
			<div
				className="container"
			>
				<div className="row">

					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							{examCycleData.title} results for {studentData.firstName} {studentData.middleName} {studentData.lastName}
							<br/>
							<span className="badge bg-primary">Exam Cycle Results</span>
						</h6>
						<hr/>
					</div>

					

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's First Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.firstName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's Middle Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.middleName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's Last Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.lastName || "N/A"}
						</h6>
					</div>
					
					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's Current Classrooom</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.classroomName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's Current Stream</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.streamName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Student's Date of Birth</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.birthDate || "N/A"}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<div className="row">

									<div className="col-12">
										<h1
											className="card-title"
										>
											Results for {examCycleData.title}
										</h1>
										<hr/>
									</div>

									<div className="col-md-12 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle Title</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{examCycleData.title || "N/A"}
										</h6>
									</div>

									<div className="col-md-4 col-6 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle Status</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{examCycleData.status || "N/A"}
										</h6>
									</div>

									<div className="col-md-4 col-6 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle Classroom</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{examCycleData.classroomData?.name || "N/A"}
										</h6>
									</div>

									<div className="col-md-4 col-6 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle Stream</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{examCycleData.streamData?.name || "N/A"}
										</h6>
									</div>

									<div className="col-md-4 col-6 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle Start Date</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{formatDate(examCycleData.dateStart).substring(0, 10)}
										</h6>
									</div>

									<div className="col-md-4 col-6 mb-3 mt-3">
										<label className="text-muted form-label">Exam Cycle End Date</label>
										<h6
											style={{
												fontSize: "16px"
											}}
											className="font-semi-bold"
										>
											{formatDate(examCycleData.dateEnd).substring(0, 10)}
										</h6>
									</div>

									{
										(currentExamCycleResults && examCycleData.isProcessed === 'yes') ?
										<>
											<div className="col-12">
												<hr/>
												<label className="text-muted form-label">Student's Position</label>
												<h6
													style={{
														fontSize: "32px"
													}}
													className="font-bold text-primary"
												>
													{(currentExamCycleResults.position !== null) ? currentExamCycleResults.position : "N/A"}
												</h6>
											</div>

											<div className="col-6 col-md-4 mt-3 mb-3">
												<label className="text-muted form-label">Average</label>
												<h6
													style={{
														fontSize: "22px"
													}}
													className="font-bold text-primary"
												>
													{(currentExamCycleResults.average !== null) ? roundToTwoDecimals(currentExamCycleResults.average) : "N/A"}
												</h6>
											</div>

											<div className="col-6 col-md-4 mt-3 mb-3">
												<label className="text-muted form-label">Total Marks</label>
												<h6
													style={{
														fontSize: "22px"
													}}
													className="font-bold text-primary"
												>
													{(currentExamCycleResults.average !== null) ? currentExamCycleResults.total : "N/A"}
												</h6>
											</div>

											<div className="col-6 col-md-4 mt-3 mb-3">
												<label className="text-muted form-label">Division</label>
												<h6
													style={{
														fontSize: "22px"
													}}
													className="font-bold text-primary"
												>
													{(currentExamCycleResults.division || "N/A")}
												</h6>
											</div>

											<div className="col-6 col-md-4 mt-3 mb-3">
												<label className="text-muted form-label">Points</label>
												<h6
													style={{
														fontSize: "22px"
													}}
													className="font-bold text-primary"
												>
													{(currentExamCycleResults.points || "N/A")}
												</h6>
											</div>

											<div className="col-12 mt-3 mb-3">
												<label className="text-muted form-label">Subjects</label>
												<table
													className="table table-bordered"
													style={{
														fontSize: "14px"
													}}
												>
													<thead>
														<tr>
															<th>Name</th>
															<th>Marks</th>
															<th>Grade</th>
														</tr>
													</thead>

													<tbody>
														{
															(currentExamCycleResults.subjects.map((item, i) => {
																return (
																	<tr key={i}>
																		<td>{getSubjectName(item.uuid)}</td>
																		<td>{item.marks}</td>
																		<td>{item.grade}</td>
																	</tr>
																)
															}))
														}
													</tbody>
												</table>
											</div>
										</>
										:
										<>
											<div className="col-12">
												<hr/>
												<h6
													style={{
														fontSize: "18px"
													}}
													className="font-semi-bold text-danger text-center"
												>
													<MdWarning size={32}/>
													<br/>
													Resuts are not available yet
												</h6>
											</div>
										</>
									}

								</div>
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}